import noop from 'lodash/noop';
import React from 'react';
export type ID = number | string;
export type OpenDrawer = Array<ID>;

export interface AccordionState {
  openDrawer: OpenDrawer;
  previousOpenDrawer: OpenDrawer | undefined;
  toggleDrawer: (drawer: ID) => void;
  dark: boolean;
  divider: boolean;
}

export const AccordionContext = React.createContext<AccordionState>({
  openDrawer: [],
  previousOpenDrawer: undefined,
  toggleDrawer: noop,
  dark: false,
  divider: false,
});

export const useAccordionContext = () => React.useContext(AccordionContext);
